var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 216,
    viewBox: "0 0 216 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2119_7",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 216,
    height: 216
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 216,
    height: 216,
    fill: "url(#pattern0_2119_7)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2119_7)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: -2,
    width: 198,
    height: 218,
    fill: "#97A4B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2119_7",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2119_7",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2119_7",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAABkElEQVR4nO3XPU4DQRBE4U64C3BKQiR+BMeBa5iLgEMjFbK0EQkBY72Z7fdJnVp2V9farpIkSZKkudxVVf459/SH6Lz8GAK//BgCv/zsOYQ0H1yaDy7NB5fmg0vzwaX54NJ8cGk+kiRJkoSj/xil+x8vekExAH5JsQH8ouIjaJ8zPXpBMQB+SbEB/KLiI2jMMzUXfmaPfj0cvaAYgAGg6AuNDTAAFH2hsQEGgKIvNDbAAFD0hcYGGACKvtDYAANA0RcaG2AAKPpCYwMMAEVfaGyAAaDoC40NMAAUfaGxAQaAoi80NsAAUPSFxgYYAIq+0NgAA0DRFxobYAAo+kJjAwwARV9obIABoOgLjQ0wABR9obEBBoCiLzQ2wABQ9IXGBhgAir7QdG/A14ClZdL5rAV8TLCoXGgOtYDnCRaVC81DLeC2qr4nWFYGz6mqrmsRrxMsLIPn3OxlXFXV+wRLy6B52z7TUs5v+GWrbhad03b5yy3/93fC0/YL4jjBUvPHHLf3+lhVN/TyJEmSJNXu/AC2E4f1svFH0wAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.f00be5f12c3cbd5d81e3e14e7d1b6395.svg";
export { ForwardRef as ReactComponent };